import React, {FC, PropsWithChildren} from 'react';

type Props = {
  noPadding?: boolean;
  title?: string;
};

export const ElementWrapper: FC<PropsWithChildren<Props>> = ({children, noPadding, title}) => (
  <div className={`border border-gray-300 rounded-md w-full ${!noPadding && 'p-3'}`}>
    {title && <h5>{title}</h5>}
    {children}
  </div>
);
